import React, { Component, createRef } from 'react';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import FilterContainer from '@components/filter-panel';
import { ModalMask } from '@components/common';
import { FIXED_FILTERS, SAVE_FILTER_PANEL_KEY } from '@components/filter-panel/constants';
import { GRAND_FILTER_FILTER_ALERT_MSG } from '@utils/constants';
import track, { CLICK_FILTERS } from '@src/utils/sensor/track';
import { uuidv4 } from '@utils';
import { defaultProps } from './propTypes';
import styles from './index.less';
import PrimaryFilterTag from '../CompareFiltersBar/PrimaryFilter';
import { checkFeature } from '@src/utils/platform/features/checkFeature';
import { FilterStatus } from './FilterStatus';

const MAX_LINE_LENGTH = 85;

class FilterDropdown extends Component {
  constructor(props) {
    super(props);
    this.container = createRef();
    this.titleRef = createRef();
    this.modalId = uuidv4();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.clickModalBg);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.clickModalBg);
  }

  clickModalBg = (event) => {
    if (event.target.id === this.modalId) {
      const {
        changeFilterContainerVisibility, // eslint-disable-line
      } = this.props;
      changeFilterContainerVisibility(false);
    }
  };

  showWidget = () => {
    if (!checkFeature('trends.base.filter_popup', true)) {
      return;
    }
    const {
      changeFilterContainerVisibility: changeFilterContainerVisibilityAction,
      appliedFilter,
      updateActiveTab: updateActiveTabAction,
      updateFilterConditions: updateFilterConditionsAction,
    } = this.props;
    /* eslint-enable */
    const fixFilterNames = FIXED_FILTERS.map((f) => f.name);
    if (
      !appliedFilter.fid &&
      !fixFilterNames.includes(appliedFilter.name) &&
      !appliedFilter.presetFid // skip for preset filter
    ) {
      updateActiveTabAction(SAVE_FILTER_PANEL_KEY);
      const { rule } = appliedFilter;
      // force user to enter name
      updateFilterConditionsAction({ name: '', rule });
    }
    track({ event: CLICK_FILTERS });
    changeFilterContainerVisibilityAction(true);
  };

  render() {
    const { filterColor, appliedFilter, visible, isGrandfatherFilter, compareOnTrendsMode } =
      this.props;
    const filterNameTokens = appliedFilter.name.split(/__/);
    const filterName = filterNameTokens.map((filterNameToken, index) => {
      if (['OR', 'AND'].includes(filterNameToken)) {
        return (
          <span
            key={index} // eslint-disable-line
            className={styles.delimiter}
          >
            {filterNameToken}
          </span>
        );
      }
      return filterNameToken;
    });

    const wrapLine = filterNameTokens.join(' ').length > MAX_LINE_LENGTH;
    const cls = classNames(styles.headerTitle, {
      [styles.dropdownActive]: visible,
      [styles.wrapLine]: wrapLine,
    });
    const grandfatherFilterIndicator = isGrandfatherFilter ? (
      <Tooltip title={GRAND_FILTER_FILTER_ALERT_MSG}>
        <span className={styles.splFilter}> *</span>
      </Tooltip>
    ) : null;

    return (
      <div className={styles.fddContainer}>
        <div className={cls}>
          {compareOnTrendsMode ? (
            <PrimaryFilterTag
              filterName={filterName}
              onEdit={this.showWidget}
              appliedFilter={appliedFilter}
            />
          ) : (
            <h2>
              <span
                className={styles.titleHolder}
                tabIndex="0"
                role="button"
                onClick={this.showWidget}
                id="trends-open-filter-popup"
              >
                <span className={styles.verticalBar} style={{ background: filterColor }} />
                <span className={styles.title} ref={this.titleRef}>
                  <FilterStatus filterName={filterName} appliedFilter={appliedFilter} />
                  {grandfatherFilterIndicator}
                </span>
              </span>
            </h2>
          )}
        </div>

        {visible ? (
          <>
            <ModalMask id={this.modalId} />
            <div className={styles.fddContent}>
              <FilterContainer />
            </div>
          </>
        ) : null}
      </div>
    );
  }
}

FilterDropdown.defaultProps = defaultProps;
export default FilterDropdown;
